import { TickerStrategy } from '@stomp/stompjs'
import { logger } from 'utils/logging'

let resolvedStrategy: TickerStrategy | undefined

const canStartBlobWorker = (): boolean => {
  let url: string | undefined
  try {
    url = URL.createObjectURL(new Blob([''], { type: 'text/javascript' }))
    new Worker(url).terminate()
    return true
  } catch (error) {
    logger.warn('Conversation socket heartbeat worker cannot start, falling back to interval heartbeats', error, {
      context: {
        component: 'ConversationSocketProvider',
        action: 'heartbeatWorkerProbe',
        metadata: { error: error instanceof Error ? `${error.name}: ${error.message}` : String(error) },
      },
    })
    return false
  } finally {
    if (url) URL.revokeObjectURL(url)
  }
}

export const resolveHeartbeatStrategy = (): TickerStrategy => {
  if (resolvedStrategy === undefined) {
    resolvedStrategy = typeof Worker !== 'undefined' && canStartBlobWorker() ? TickerStrategy.Worker : TickerStrategy.Interval
  }
  return resolvedStrategy
}
